import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StoreAddSiteService } from '@services/cleanfill-core/site-management/store-add-site.service';
import { PanelComponent } from '@widgets/site-common/panels/panel/panel.component';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'panels',
  templateUrl: './panels.component.html',
  styleUrls: ['./panels.component.scss']
})
export class PanelsComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() startAt = 0;
  @Input() notShowBackground = false;
  @Output() panelChanged = new EventEmitter<number>();
  @ContentChildren(PanelComponent) panels: QueryList<PanelComponent>;
  activePanelIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  lastPanelActive$: Observable<boolean>;
  subscription = new Subscription();
  constructor(private addSiteService: StoreAddSiteService) {}
  isshow = false;

  get activePanelIndex() {
    return this.activePanelIndex$.value;
  }

  ngAfterContentInit(): void {
    this.activePanelIndex$ = new BehaviorSubject(Number(this.startAt) || 0);
    this.lastPanelActive$ = this.activePanelIndex$.asObservable().pipe(map(index => index === this.panels.length - 1));
  }

  ngOnInit() {}
  reset() {
    this.activePanelIndex$.next(0);
  }
  resetLast() {
    const lastPanelIndex = this.panels.toArray().filter(t => !t.hidden).length - 1;
    if (lastPanelIndex === 1) {
      this.activePanelIndex$.next(0);
    } else {
      this.activePanelIndex$.next(lastPanelIndex);
    }
  }

  selectPanel(index: number): void {
    const currIndex = this.activePanelIndex$.value;
    if (currIndex === index) {
      return;
    }
    // if (this.startAt === 0) {
    this.markPanelFormAsTouched(currIndex);
    // }
    this.activePanelIndex$.next(index);
    if (this.activePanelIndex$.value === 3 && !this.notShowBackground) {
      this.isshow = true;
    } else {
      this.isshow = false;
    }
    this.panelChanged.emit(index);
  }

  nextPanel(): void {
    const panels = this.panels.toArray();
    const currIndex = this.activePanelIndex$.value;
    let newIndex = currIndex;
    for (let i = newIndex + 1; i < panels.length; i++) {
      if (!panels[i].hidden) {
        newIndex = i;
        break;
      }
    }

    if (newIndex >= this.panels.length) {
      return;
    }
    this.selectPanel(newIndex);
  }

  previousPanel(): void {
    const newIndex = this.activePanelIndex$.value - 1;
    if (newIndex) {
      return;
    }

    this.selectPanel(newIndex);
  }

  private markPanelFormAsTouched(index: number): void {
    const panels = this.panels.toArray();
    const panelForm: FormGroup = panels[index]?.form;
    if (!panelForm) {
      return;
    }

    panelForm.markAllAsTouched();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
